import CoreuiController from "../lib/coreui-controller"
import ScrollSpy from "../coreui/scroll-spy"

export default class CoreuiScrollSpyController extends CoreuiController {
  static Component = ScrollSpy
}
